module.exports = __webpack_public_path__ + "img/europe.84580547.svg";